import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { prepareStep, prepareInitialValues } from '../../../../../utils/steps'

import { getDatabase, fetchDatabases } from '../../../../../ducks/databases'
import { FullScreenLoader } from '../../../../Shared/Loading'
import Form from './Form'

export default function ConfigureStep({ step, action, onSave }) {
  const { databaseId } = step || {}
  const database = useSelector(getDatabase(databaseId))
  const dispatch = useDispatch()

  const organizationId = action && action.OrganizationId

  useEffect(() => {
    if (organizationId) {
      dispatch(fetchDatabases(organizationId))
    }
  }, [dispatch, organizationId])

  if (!action || !database) {
    return <FullScreenLoader />
  }

  const initialValues = prepareInitialValues(step, database)

  const handleSubmit = data => {
    let [newStep, newInputs] = prepareStep(data, action, { database })

    return onSave(newStep, newInputs)
  }

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={initialValues}
      database={database}
      action={action}
      stepId={step.id}
    />
  )
}
